// ProfileSidebar.jsx
import { motion } from "framer-motion";
import ScrollAnimation from "../../../hooks/ScrollAnimation";
import StarRating from "../../section/StarRating";

const ProfileSidebar = ({ userData, tabs, activeTab, setActiveTab }) => {
  return (
    <ScrollAnimation direction="left" delay={0.1}>
      <motion.div
        className="lg:w-80 flex-shrink-0 bg-white rounded-xl shadow-lg p-6 h-fit"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        {/* Profile Info */}
        <div className="text-center mb-6">
          <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
            {userData.profilePicture ? (
              <img src={userData.profilePicture} alt="Profile" className="w-20 h-20 rounded-full object-cover" />
            ) : (
              <span className="text-2xl text-blue-600">{userData.name.charAt(0).toUpperCase()}</span>
            )}
          </div>
          <h3 className="text-lg font-semibold text-gray-900 truncate">{userData.name}</h3>
          <p className="text-sm text-gray-600 break-words">{userData.email}</p>

          {userData.isLawFirm && (
            <div className="mt-2 space-y-2">
              <span className="bg-yellow-100 text-yellow-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
                {userData.subscriptionType} Plan
              </span>
              <p className="text-xs text-gray-500">Est. {userData.firmDetails.establishedYear}</p>
              <div className="flex items-center justify-center space-x-2">
                <StarRating rating={userData.firmRating} size="sm" showNumber={true} />
                <span className="text-xs text-gray-500">({userData.totalReviews} reviews)</span>
              </div>
            </div>
          )}
        </div>

        {/* Navigation Tabs */}
        <nav className="space-y-2">
          {tabs.map((tab) => (
            <motion.button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`w-full flex items-center px-4 py-3 text-left rounded-lg transition-all duration-200 ${
                activeTab === tab.id
                  ? "bg-blue-50 text-blue-700 border-l-4 border-blue-500"
                  : "text-gray-700 hover:bg-gray-50"
              }`}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <span className="text-lg mr-3 flex-shrink-0">{tab.icon}</span>
              <span className="font-medium whitespace-nowrap">{tab.label}</span>
            </motion.button>
          ))}
        </nav>

        {/* Quick Stats - فقط لـ office_owner */}
        {userData.role === "office_owner" && (
          <div className="mt-8 pt-6 border-t border-gray-200">
            <h4 className="text-sm font-semibold text-gray-900 mb-3">Quick Stats</h4>
            <div className="space-y-3">
              <div className="flex justify-between items-center text-sm">
                <span className="text-gray-600">Active Lawyers</span>
                <span className="font-medium text-gray-900">8/15</span>
              </div>
              <div className="flex justify-between items-center text-sm">
                <span className="text-gray-600">Client Requests</span>
                <span className="font-medium text-gray-900">12</span>
              </div>
              <div className="flex justify-between items-center text-sm">
                <span className="text-gray-600">Monthly Revenue</span>
                <span className="font-medium text-gray-900">$15,200</span>
              </div>
              <div className="flex justify-between items-center text-sm">
                <span className="text-gray-600">Total Clients</span>
                <span className="font-medium text-gray-900">47</span>
              </div>
            </div>
          </div>
        )}
      </motion.div>
    </ScrollAnimation>
  );
};

export default ProfileSidebar;